<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
    </div>
    <div class="info_img" v-if="userinfo.image">
      <img :src="imgUrl + userinfo?.image" alt="" />
    </div>
    <div class="info_img" v-else>
      <img src="@/assets/newMedal/publicWelfare/bg2.png" alt="" />
    </div>
    <div class="content">
      <div class="title">{{ userinfo.title }}</div>
      <div class="describe">
        {{ userinfo.actDescribe }}
      </div>
      <div class="info_list">
        <div class="info_item">
          <div class="info_label">活动日期:</div>
          <div class="info_value">
            {{ userinfo.startTime }} <span style="margin: 0 5px">—</span>
            {{ userinfo?.endTime }}
          </div>
        </div>
        <div class="info_item">
          <div class="info_label">组&nbsp;织&nbsp;人:</div>
          <div class="info_value">{{ userinfo.leaderName }}</div>
        </div>
        <!-- <div class="info_item">
          <div class="info_label">岗位描述:</div>
          <div class="info_value">{{ userinfo.jobDescribe }}</div>
        </div> -->
        <div class="info_item">
          <div class="info_label">报名要求:</div>
          <div class="info_value" v-html="userinfo.requirement"></div>
        </div>
        <div class="info_item">
          <div class="info_label">已报名:</div>
          <div class="info_value">
            <span
              style="color: #2e93fa"
              @click="
                toSign(
                  '/mobile/medal/publicWelfare/signStatisticsDetail',
                  (type = 2)
                )
              "
              >{{ userinfo.applyNum }}</span
            >/{{ userinfo.num }}人
          </div>
        </div>
        <div class="info_item">
          <div class="info_label">推送对象:</div>
          <div class="info_value">{{ userinfo.departmentName }}</div>
        </div>
        <div class="info_item">
          <div class="info_label">签到位置:</div>
          <div class="info_value">{{ userinfo.place }}</div>
        </div>
        <div
          class="info_dl"
          v-if="userinfo.leaderNo?.includes($store.state.userInfo.username)"
        >
          <div class="info_left">
            <div
              class="bookcode"
              id="qrcode"
              ref="qrcode"
              @click="toUrl('/mobile/medal/publicWelfare/shareCode')"
            ></div>
            <div class="info_text">签到二维码</div>
          </div>
          <div class="info_right">
            <img
              src="@/assets/newMedal/publicWelfare/sign.png"
              alt=""
              style="width: 70px; height: 70px"
              @click="toUrl('/mobile/medal/publicWelfare/signStatistics')"
            />
            <div class="info_text">签到统计</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button
        v-if="userinfo.state == 1 && userinfo.isApply == 0"
        class="btn1"
        @click="toRouter('/mobile/medal/publicWelfare/registration', userinfo)"
        >报名</el-button
      >
      <el-button
        v-if="userinfo.state == 1 && userinfo.isApply == 1"
        class="btn1"
        @click="noSignUp"
        >取消报名</el-button
      >
      <el-button v-if="userinfo.state == 3" class="btn3">活动已结束</el-button>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import api from "@/apis/publicWelfare";
import apis from "@/apis/medal";
import moment from "moment";
import { getToken } from "@/utils/cookie";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      imgUrl: "",
      userinfo: {},
      shareValue: "",
    };
  },
  created() {},
  mounted() {
    this.imgUrl = apis.imgUrl;
    this.shareValue = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww086cfff9688fbdfc&redirect_uri=http://qw.nvc-lighting.com.cn:8088/mobile/medal/publicWelfare/sign?id=${this.$route.query.id}&response_type=code&scope=SCOPE&state=STATE#wechat_redirect"`;
    this.getInfo();
  },
  methods: {
    // 取消报名
    noSignUp() {
      api
        .cancel({
          activityId: this.userinfo.id,
          empNo: getToken(),
        })
        .then(() => {
          this.$message({
            message: "取消报名成功",
            type: "success",
            duration: 2000,
          });
          this.getInfo();
        });
    },
    // 获取公益详情
    getInfo() {
      api
        .detail({
          id: this.$route.query.id,
          empNo: getToken(),
        })
        .then((res) => {
          if (res.code == 200) {
            this.userinfo = res.data;
            this.userinfo.startTime = moment(this.userinfo.startTime).format(
              "YYYY/MM/DD HH:mm"
            );
            this.userinfo.endTime = moment(this.userinfo.endTime).format(
              "YYYY/MM/DD HH:mm"
            );
            if (
              this.userinfo.leaderNo?.includes(
                this.$store.state.userInfo.username
              )
            ) {
              this.qrcode();
            }
          }
        });
    },
    //返回
    goback() {
      this.$router.go(-1);
    },
    // 生成二维码
    qrcode() {
      this.$nextTick(() => {
        const qrContainer = document.getElementById("qrcode");
        if (qrContainer) {
          qrContainer.innerHTML = ""; // 清空容器内容
        }
        let qrcode = new QRCode("qrcode", {
          width: 70, //图像宽度
          height: 70, //图像高度
          colorDark: "#000000", //前景色
          colorLight: "#ffffff", //背景色
          typeNumber: 4,
          correctLevel: QRCode.CorrectLevel.L,
        });
        qrcode.clear(); //清除二维码
        qrcode.makeCode(this.shareValue);
      });
    },
    // 跳转
    toUrl(path) {
      this.$router.push({
        path: path,
        query: {
          id: this.$route.query.id,
        },
      });
    },
    // 跳转报名
    toRouter(path, item) {
      if (item?.applyNum == item?.num) {
        this.$message({
          type: "warning", // success error warning
          message: "当前活动报名人数已满",
          duration: 2000,
        });
      } else {
        this.$router.push({
          path: path,
          query: {
            itemUrl: JSON.stringify(item),
          },
        });
      }
    },
    // 跳转签到统计
    toSign(path, type) {
      this.$router.push({
        path: path,
        query: { type: type, id: this.$route.query.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .info_img {
    width: 100%;
    height: 120px * $zoom;
    img {
      width: 100%;
      height: 100%;
      border-radius: 40px;
    }
  }
  .content {
    background: #fff;
    width: 100%;
    border-radius: 25px;
    padding: 30px;
    margin-top: 30px;
    .title {
      font-size: 13px * $zoom;
      text-align: center;
    }
    .describe {
      margin-top: 30px;
      font-size: 10px * $zoom;
      color: #666;
      word-break: break-word;
      white-space: normal;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .info_list {
      .info_item {
        display: flex;
        align-items: flex-start;
        margin: 30px 0;
        .info_label {
          width: 50px * $zoom;
          font-size: 10px * $zoom;
          color: #666;
        }
        .info_value {
          flex: 1;
          font-size: 10px * $zoom;
          flex-wrap: wrap;
          color: #282b32;
          margin-top: 1px * $zoom;
          font-weight: bold;
        }
      }
    }
    .info_dl {
      font-size: 10px * $zoom;
      color: #000;
      margin-top: 80px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      .info_left {
        width: 50%;
        text-align: center;
        .bookcode {
          display: flex;
          justify-content: center;
        }
        .info_text {
          margin-top: 20px;
        }
      }
      .info_right {
        width: 50%;
        text-align: center;
        .info_text {
          margin-top: 15px;
        }
      }
    }
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
.footer {
  .btn2 {
    border: 1px solid #1fbe8a;
    background: none;
    color: #1fbe8a;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 0 0 30px !important;
    border-radius: 15px;
  }
  .btn1 {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 60px 0 30px;
    border-radius: 15px;
  }
  .btn3 {
    border: 1px solid #ccc;
    background: none;
    color: #ccc;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 60px 0 30px !important;
    border-radius: 15px;
  }
}
</style>
